import React, {Component} from 'react'
import {Switch, Route} from 'react-router-dom'
import './stylesheets/index.css'
import Login from './Login'
import Account from './Account'
import Inventory from './Inventory'
import KegScanner from './KegScanner'
import Reservations from './Reservations'
import Customers from './Customers'
import Accounting from './Accounting'
import Products from './Products'
import Kegs from './Kegs'
import UpdateProduct from './Products/update'
import Settings from './Settings'
import NewReservation from './Reservations/new'
import ShowReservation from './Reservations/ShowOrder'
import NewProduct from './Products/new'
import Enforcement from './Enforcement'
import SignUp from './SignUp'
import AccountInfo from './SignUp/account_info'
import AccountSettings from './SignUp/account_settings'
import BankAccountForm from './SignUp/account_bank_form'
import Checkout from './Checkout'
import Cheers from './Cheers'
import AccountCheers from './AccountCheers'
import BadPermission from './BadPermissions'
import PrivateRoute from './PrivateRoute'
import Main from './Main'
import Tips from './Tips'
import ShowCustomer from './Customers/Show'
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import './stylesheets/App.sass'

const customComponent = (props) => {
  return (
    <div className={'km-alert ' + props.classNames} id={props.id} style={props.styles}>
      <div className='s-alert-box-inner'>
        {props.message}
      </div>
    </div>
  )
}

class App extends Component {

  render() {
    const {routerComponent: BrowserRouter, history} = this.props
    return (
      <div>
        <BrowserRouter history={history}>
          <Switch>
            <Route exact name='index' path='/' component={Login} />
            <PrivateRoute minimumRouteRole='admin' exact history={history} name='account' path='/account' component={Account} />
            <PrivateRoute minimumRouteRole='admin' exact history={history} name='account_cheers' path='/account_cheers' component={AccountCheers} />
            <PrivateRoute minimumRouteRole='admin' exact history={history} name='bank_account_info' path='/bank_account_info' component={BankAccountForm} />
            <PrivateRoute minimumRouteRole='admin' exact history={history} name='inventory' path='/inventory' component={Inventory} />
            <PrivateRoute minimumRouteRole='admin' exact history={history} name='new_product' path='/new_product' component={NewProduct} />
            <PrivateRoute minimumRouteRole='admin' exact history={history} name='account_information' path='/account_information' component={AccountInfo} />
            <PrivateRoute minimumRouteRole='admin' exact history={history} name='product' path='/product' component={UpdateProduct} />
            <PrivateRoute minimumRouteRole='admin' exact history={history} name='account_settings' path='/account_settings' component={AccountSettings} />
            <PrivateRoute minimumRouteRole='accountant' history={history} exact name='accounting' path='/accounting' component={Accounting} />
            <PrivateRoute minimumRouteRole='user' history={history} exact name='show_customer' path='/customer/:customer_id' component={ShowCustomer} />
            <PrivateRoute minimumRouteRole='user' exact history={history} name='keg_scanner' path='/keg_scanner' component={KegScanner} />
            <PrivateRoute minimumRouteRole='user' exact history={history} name='reservations' path='/reservations' component={Reservations} />
            <PrivateRoute minimumRouteRole='user' exact history={history} name='show_reservations' path='/reservations/:reservation_id' component={ShowReservation} />
            <PrivateRoute minimumRouteRole='user' exact history={history} name='customers' path='/customers' component={Customers} />
            <PrivateRoute minimumRouteRole='user' exact history={history} name='products' path='/products' component={Products} />
            <PrivateRoute minimumRouteRole='user' exact history={history} name='kegs' path='/kegs' component={Kegs} />
            <PrivateRoute minimumRouteRole='user' exact history={history} name='settings' path='/settings' component={Settings} />
            <PrivateRoute exact history={history} name='enforcement' path='/enforcement' component={Enforcement} />
            <Route exact name='cheers' path='/cheers' component={Cheers} />
            <Route exact name='sign_up' path='/sign_up' component={SignUp} />
            <Route exact name='sign_up/:link_id' path='/sign_up/:link_id' component={SignUp} />
            <Route exact name='checkout' path='/checkout/:orderId' component={Checkout} />
            <Route exact name='new_reservation' history={history} path='/new_reservation/:company_id' component={NewReservation} />
            <Route exact strict path="/tips/:orderId" history={history} component={Tips} />
            <Route exact name='new_customer_reservation' history={history} path='/new_reservation/:company_id/customer/:customer_id' component={NewReservation} />
            <Route history={history} exact name='bad_permission' path='/wrong' component={BadPermission} />
          </Switch>
        </BrowserRouter>
        <Alert
          contentTemplate={customComponent}
          position={'bottom-right'}
          stack={{limit: 3}}
          effect={'slide'}
          html={true}
        />
      </div>
    )
  }
};


export default App



// WEBPACK FOOTER //
// ./src/App.js